import { render, staticRenderFns } from "./OverviewCta.vue?vue&type=template&id=37bf6764"
import script from "./OverviewCta.vue?vue&type=script&lang=js"
export * from "./OverviewCta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports